export default __webpack_public_path__ + "0ad93a947e2dbc3f525ab194ef95777e.svg";